




















import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import PopupMenu from '@/components/shipment/PopupMenu.vue'
import shipmentStore from '@/stores/ShipmentStore'
import ShipmentListItems from '@/components/shipment/ShipmentListItems.vue'

@Component({
  components: { ShipmentListItems, PopupMenu },
})
export default class ShipmentList extends Vue {
  shipmentStore = shipmentStore

  get pointGroups() {
    return this.shipmentStore.pointsGroupsAsArray
  }
}
